import { render } from "./Sider.vue?vue&type=template&id=65fd64ae&scoped=true"
import script from "./Sider.vue?vue&type=script&lang=js"
export * from "./Sider.vue?vue&type=script&lang=js"

import "./Sider.vue?vue&type=style&index=0&id=65fd64ae&scoped=true&lang=css"
import "./Sider.vue?vue&type=style&index=1&id=65fd64ae&lang=css"

import exportComponent from "/codebuild/output/src1932422480/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65fd64ae"]])

export default __exports__